/* eslint-disable import/prefer-default-export */
export const isValidDate = (date: string): boolean => {
  if (date) {
    if (!Number.isNaN(Date.parse(date))) return true;
    return false;
  }
  return false;
};
